import { useCallback, useEffect, useState } from 'react';
import type { THEMES } from '../../constants/Consts';
import { useEvent } from '../../hooks/api/useEvent';
import { eventModules } from './Consts';
import type { EventModule } from '../../types/event';

interface EventProps {
  selectedThemeType: THEMES;
}

export const Event = ({ selectedThemeType }: EventProps) => {
  const { activeEvents, eventEntries, getActiveEvents, getEventEntries } = useEvent();
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [showEnteredModal, setShowEnteredModal] = useState(false);
  const [eventModule, setEventModule] = useState<EventModule | null>(null);

  useEffect(() => {
    getActiveEvents();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activeEvent = activeEvents?.[0];
  const entryInfo = eventEntries?.[0];

  useEffect(() => {
    if (!activeEvent?.code) return;
    const loader = eventModules[activeEvent.code];
    if (!loader) return;
    loader().then((mod) => setEventModule(mod.default)).catch((e: unknown) => console.error('Failed to load event module:', e));
  }, [activeEvent?.code]);

  useEffect(() => {
    if (!activeEvent?.eventId) return;
    getEventEntries(activeEvent.eventId);
  }, [activeEvent, getEventEntries]);


  const handleEntryComplete = useCallback(() => {
    setShowEntryForm(false);
    if (activeEvent?.eventId) {
      getEventEntries(activeEvent.eventId);
    }
  }, [activeEvent, getEventEntries]);

  if (!activeEvent || !eventModule || !eventModule.targetThemes.includes(selectedThemeType)) {
    return null;
  }

  return (
    <>
      <eventModule.PhaseBanner
        event={activeEvent}
        targetThemes={eventModule.targetThemes}
        hasEntry={!!entryInfo}
        onClickEntry={() => setShowEntryForm(true)}
        onClickEntered={() => setShowEnteredModal(true)}
      />
      {showEntryForm && activeEvent.eventId && (
        <eventModule.EntryModal
          event={activeEvent}
          onClose={() => setShowEntryForm(false)}
          onEntryComplete={handleEntryComplete}
        />
      )}
      {showEnteredModal && entryInfo && (
        <eventModule.EnteredModal
          entryInfo={entryInfo}
          onClose={() => setShowEnteredModal(false)}
        />
      )}
    </>
  );
};
